import { useState } from "react";

import { Select } from "@/components/inputs";
import { useProducts, type Product } from "@/modules/products/fixtures";

/** Every section below Products is ABOUT one product, so each one picks it the
 *  same way — one control, in the same place, on every page.
 *
 *  This is why the sections are module-level subpages rather than tabs inside a
 *  product: every other module in the console works this way (Registry, FOTA,
 *  Asset Data each have 3–6 subpages, each filtered), and a person looking for
 *  "where are tool releases" should find it in the rail, not by clicking a row
 *  first and discovering tabs.
 */
export function useProductPicker(): { product: Product; picker: JSX.Element } {
  const products = useProducts();
  const [id, setId] = useState(products[0]?.product_id ?? "");
  const product = products.find((p) => p.product_id === id) ?? products[0];

  const picker = (
    <label style={{ display: "flex", alignItems: "center", gap: 8 }}>
      <span className="cap">Product</span>
      <Select value={product?.product_id ?? ""} onChange={(e) => setId(e.target.value)}
        style={{ minWidth: 220 }}>
        {products.map((p) => (
          <option key={p.product_id} value={p.product_id}>{p.name}</option>
        ))}
      </Select>
    </label>
  );

  return { product, picker };
}
